import { IPositionDialogContentProps, Position } from "@/Washouts/types/PositionsDialog";
import { Checkbox, DialogContent, FormControlLabel, Grid, Typography } from "@mui/material";

export const PositionDialogContent = (props: IPositionDialogContentProps) => {
	const { sx, payPeriodPosition, isCheckedAll, handleCheckedAll, selectedPositions, handleTogglePosition } = props;
	return (
		<DialogContent sx={{ maxWidth: "520px", minWidth: "520px", px: "32px", py: 0, ...sx }}>
			<Grid container direction="column">
				<Grid item sx={{ mb: "10px" }}>
					<Grid container>
						<Grid item>
							<FormControlLabel
								control={<Checkbox checked={isCheckedAll} onChange={(_, value) => handleCheckedAll(value)} />}
								label={<Typography variant="appLabel">Select All</Typography>}
								labelPlacement="end"
								className="payroll-submission-position"
							/>
						</Grid>
					</Grid>
				</Grid>

				<Grid item>
					<Grid container>
						{payPeriodPosition?.map((position: Position, i) => {
							const checked = selectedPositions.includes(position.name);
							return (
								<Grid item key={`${position.name}_${i}`} xs={6}>
									<Grid container direction={"row"}>
										<Grid item>
											<FormControlLabel
												control={
													<Checkbox
														checked={checked}
														disabled={position.disabled}
														onChange={() => handleTogglePosition(position.name)}
													/>
												}
												disabled={position.disabled}
												label={<Typography variant="appLabel">{position.name}</Typography>}
												labelPlacement="end"
												className="payroll-submission-position"
											/>
										</Grid>
									</Grid>
								</Grid>
							);
						})}

						{!payPeriodPosition?.length && <Typography variant="appInfoText">No positions available for selection.</Typography>}
					</Grid>
				</Grid>
			</Grid>
		</DialogContent>
	);
};
